// Theme configuration for ecommerce store buyer pages
// Defines styling and layout for 10 desktop and 10 mobile themes

export const THEME_CONFIGS = {
  // ==================== DESKTOP THEMES ====================
  desktop: {
    swiggy: {
      name: 'Swiggy Style',
      description: 'Card Grid with Side Cart',
      layout: 'grid',
      productCard: {
        style: 'elevated',
        imageHeight: 180,
        borderRadius: 12,
        shadow: '0 2px 8px rgba(0,0,0,0.08)',
        hoverShadow: '0 4px 16px rgba(0,0,0,0.12)',
        padding: 16
      },
      cart: {
        position: 'side',
        width: 360,
        sticky: true,
        background: '#ffffff',
        shadow: '-2px 0 8px rgba(0,0,0,0.06)'
      },
      grid: {
        columns: { xs: 1, sm: 2, md: 2, lg: 3 },
        spacing: 2
      }
    },
    
    zomato: {
      name: 'Zomato Style',
      description: 'List View with Sticky Cart',
      layout: 'list',
      productCard: {
        style: 'horizontal',
        imageHeight: 120,
        imageWidth: 160,
        borderRadius: 8,
        shadow: '0 1px 4px rgba(0,0,0,0.06)',
        hoverShadow: '0 2px 8px rgba(0,0,0,0.1)',
        padding: 12
      },
      cart: {
        position: 'sticky-bottom',
        width: '100%',
        sticky: true,
        background: '#ffffff',
        shadow: '0 -2px 8px rgba(0,0,0,0.08)'
      },
      grid: {
        columns: { xs: 1, sm: 1, md: 1, lg: 1 },
        spacing: 1.5
      }
    },
    
    ubereats: {
      name: 'Uber Eats Style',
      description: 'Large Cards with Bottom Cart',
      layout: 'grid',
      productCard: {
        style: 'large',
        imageHeight: 220,
        borderRadius: 16,
        shadow: '0 2px 12px rgba(0,0,0,0.08)',
        hoverShadow: '0 4px 20px rgba(0,0,0,0.15)',
        padding: 20
      },
      cart: {
        position: 'bottom-bar',
        width: '100%',
        sticky: true,
        background: '#000000',
        textColor: '#ffffff',
        shadow: '0 -4px 12px rgba(0,0,0,0.15)'
      },
      grid: {
        columns: { xs: 1, sm: 2, md: 2, lg: 2 },
        spacing: 3
      }
    },
    
    doordash: {
      name: 'DoorDash Style',
      description: 'Compact Grid with Floating Cart',
      layout: 'grid',
      productCard: {
        style: 'compact',
        imageHeight: 140,
        borderRadius: 10,
        shadow: '0 1px 6px rgba(0,0,0,0.06)',
        hoverShadow: '0 3px 12px rgba(0,0,0,0.1)',
        padding: 12
      },
      cart: {
        position: 'floating',
        width: 340,
        sticky: false,
        background: '#ffffff',
        shadow: '0 4px 16px rgba(0,0,0,0.12)',
        borderRadius: 16
      },
      grid: {
        columns: { xs: 1, sm: 2, md: 3, lg: 4 },
        spacing: 2
      }
    },
    
    grubhub: {
      name: 'GrubHub Style',
      description: 'Wide Cards with Right Panel',
      layout: 'list',
      productCard: {
        style: 'wide',
        imageHeight: 140,
        imageWidth: 200,
        borderRadius: 12,
        shadow: '0 2px 8px rgba(0,0,0,0.06)',
        hoverShadow: '0 3px 12px rgba(0,0,0,0.1)',
        padding: 16
      },
      cart: {
        position: 'side-panel',
        width: 380,
        sticky: true,
        background: '#f8f9fa',
        shadow: '-2px 0 12px rgba(0,0,0,0.06)'
      },
      grid: {
        columns: { xs: 1, sm: 1, md: 1, lg: 1 },
        spacing: 2
      }
    },
    
    deliveroo: {
      name: 'Deliveroo Style',
      description: 'Minimal Cards with Drawer Cart',
      layout: 'grid',
      productCard: {
        style: 'minimal',
        imageHeight: 160,
        borderRadius: 8,
        shadow: 'none',
        border: '1px solid #e5e7eb',
        hoverShadow: '0 2px 8px rgba(0,0,0,0.08)',
        padding: 12
      },
      cart: {
        position: 'drawer',
        width: 420,
        sticky: false,
        background: '#ffffff',
        shadow: '-4px 0 16px rgba(0,0,0,0.1)'
      },
      grid: {
        columns: { xs: 1, sm: 2, md: 3, lg: 3 },
        spacing: 2
      }
    },
    
    postmates: {
      name: 'Postmates Style',
      description: 'Photo Focus with Overlay Cart',
      layout: 'grid',
      productCard: {
        style: 'photo-focus',
        imageHeight: 240,
        borderRadius: 20,
        shadow: '0 3px 12px rgba(0,0,0,0.1)',
        hoverShadow: '0 6px 24px rgba(0,0,0,0.15)',
        padding: 0,
        overlay: true
      },
      cart: {
        position: 'overlay',
        width: 400,
        sticky: false,
        background: 'rgba(255,255,255,0.98)',
        backdropBlur: '10px',
        shadow: '0 8px 32px rgba(0,0,0,0.15)',
        borderRadius: 20
      },
      grid: {
        columns: { xs: 1, sm: 2, md: 2, lg: 3 },
        spacing: 3
      }
    },
    
    seamless: {
      name: 'Seamless Style',
      description: 'Classic List with Fixed Cart',
      layout: 'list',
      productCard: {
        style: 'classic',
        imageHeight: 100,
        imageWidth: 140,
        borderRadius: 6,
        shadow: '0 1px 3px rgba(0,0,0,0.06)',
        hoverShadow: '0 2px 6px rgba(0,0,0,0.08)',
        padding: 12
      },
      cart: {
        position: 'fixed-right',
        width: 320,
        sticky: true,
        background: '#ffffff',
        shadow: '-2px 0 8px rgba(0,0,0,0.06)',
        border: '1px solid #e5e7eb'
      },
      grid: {
        columns: { xs: 1, sm: 1, md: 1, lg: 1 },
        spacing: 1
      }
    },
    
    caviar: {
      name: 'Caviar Style',
      description: 'Premium Grid with Elegant Cart',
      layout: 'grid',
      productCard: {
        style: 'premium',
        imageHeight: 200,
        borderRadius: 16,
        shadow: '0 2px 16px rgba(0,0,0,0.08)',
        hoverShadow: '0 4px 24px rgba(0,0,0,0.12)',
        padding: 20,
        border: '1px solid #f3f4f6'
      },
      cart: {
        position: 'elegant-side',
        width: 400,
        sticky: true,
        background: '#fafafa',
        shadow: '-3px 0 16px rgba(0,0,0,0.06)',
        borderRadius: 12
      },
      grid: {
        columns: { xs: 1, sm: 2, md: 2, lg: 3 },
        spacing: 3
      }
    },
    
    instacart: {
      name: 'Instacart Style',
      description: 'Category Tabs with Quick Add',
      layout: 'grid',
      productCard: {
        style: 'quick-add',
        imageHeight: 160,
        borderRadius: 12,
        shadow: '0 2px 8px rgba(0,0,0,0.06)',
        hoverShadow: '0 3px 12px rgba(0,0,0,0.1)',
        padding: 12,
        quickAdd: true
      },
      cart: {
        position: 'sticky-top',
        width: '100%',
        sticky: true,
        background: '#ffffff',
        shadow: '0 2px 8px rgba(0,0,0,0.06)',
        compact: true
      },
      grid: {
        columns: { xs: 2, sm: 3, md: 4, lg: 5 },
        spacing: 2
      }
    }
  },
  
  // ==================== MOBILE THEMES ====================
  mobile: {
    swiggy: {
      name: 'Swiggy Mobile',
      description: 'Bottom Sheet Cart',
      layout: 'grid',
      productCard: {
        style: 'mobile-card',
        imageHeight: 140,
        borderRadius: 12,
        shadow: '0 2px 8px rgba(0,0,0,0.08)',
        padding: 12
      },
      cart: {
        type: 'bottom-sheet',
        maxHeight: '80vh',
        background: '#ffffff',
        borderRadius: '20px 20px 0 0',
        shadow: '0 -4px 16px rgba(0,0,0,0.12)'
      },
      grid: {
        columns: 1,
        spacing: 2
      }
    },
    
    zomato: {
      name: 'Zomato Mobile',
      description: 'Slide Up Cart',
      layout: 'list',
      productCard: {
        style: 'mobile-list',
        imageHeight: 100,
        imageWidth: 120,
        borderRadius: 8,
        shadow: '0 1px 4px rgba(0,0,0,0.06)',
        padding: 12
      },
      cart: {
        type: 'slide-up',
        maxHeight: '70vh',
        background: '#ffffff',
        borderRadius: '16px 16px 0 0',
        shadow: '0 -2px 12px rgba(0,0,0,0.1)'
      },
      grid: {
        columns: 1,
        spacing: 1.5
      }
    },
    
    ubereats: {
      name: 'Uber Eats Mobile',
      description: 'Full Screen Cart',
      layout: 'grid',
      productCard: {
        style: 'mobile-large',
        imageHeight: 180,
        borderRadius: 12,
        shadow: '0 2px 8px rgba(0,0,0,0.08)',
        padding: 16
      },
      cart: {
        type: 'fullscreen',
        background: '#000000',
        textColor: '#ffffff',
        animation: 'slide-left'
      },
      grid: {
        columns: 1,
        spacing: 2
      }
    },
    
    doordash: {
      name: 'DoorDash Mobile',
      description: 'Sticky Bottom Bar',
      layout: 'grid',
      productCard: {
        style: 'mobile-compact',
        imageHeight: 120,
        borderRadius: 10,
        shadow: '0 1px 6px rgba(0,0,0,0.06)',
        padding: 10
      },
      cart: {
        type: 'sticky-bar',
        height: 64,
        background: '#ffffff',
        shadow: '0 -2px 8px rgba(0,0,0,0.08)',
        expandable: true
      },
      grid: {
        columns: 2,
        spacing: 1.5
      }
    },
    
    grubhub: {
      name: 'GrubHub Mobile',
      description: 'Drawer Cart',
      layout: 'list',
      productCard: {
        style: 'mobile-horizontal',
        imageHeight: 100,
        imageWidth: 120,
        borderRadius: 8,
        shadow: '0 1px 4px rgba(0,0,0,0.06)',
        padding: 12
      },
      cart: {
        type: 'drawer',
        width: '85vw',
        background: '#ffffff',
        shadow: '-4px 0 16px rgba(0,0,0,0.15)',
        animation: 'slide-right'
      },
      grid: {
        columns: 1,
        spacing: 1.5
      }
    },
    
    deliveroo: {
      name: 'Deliveroo Mobile',
      description: 'Modal Cart',
      layout: 'grid',
      productCard: {
        style: 'mobile-minimal',
        imageHeight: 140,
        borderRadius: 8,
        shadow: 'none',
        border: '1px solid #e5e7eb',
        padding: 10
      },
      cart: {
        type: 'modal',
        maxHeight: '75vh',
        background: '#ffffff',
        borderRadius: 16,
        shadow: '0 8px 32px rgba(0,0,0,0.15)'
      },
      grid: {
        columns: 2,
        spacing: 1.5
      }
    },
    
    postmates: {
      name: 'Postmates Mobile',
      description: 'Expandable Footer',
      layout: 'grid',
      productCard: {
        style: 'mobile-photo',
        imageHeight: 160,
        borderRadius: 12,
        shadow: '0 2px 8px rgba(0,0,0,0.08)',
        padding: 0,
        overlay: true
      },
      cart: {
        type: 'expandable-footer',
        collapsedHeight: 72,
        expandedHeight: '80vh',
        background: '#ffffff',
        borderRadius: '20px 20px 0 0',
        shadow: '0 -4px 16px rgba(0,0,0,0.12)'
      },
      grid: {
        columns: 1,
        spacing: 2
      }
    },
    
    seamless: {
      name: 'Seamless Mobile',
      description: 'Fixed Bottom Cart',
      layout: 'list',
      productCard: {
        style: 'mobile-classic',
        imageHeight: 90,
        imageWidth: 110,
        borderRadius: 6,
        shadow: '0 1px 3px rgba(0,0,0,0.06)',
        padding: 10
      },
      cart: {
        type: 'fixed-bottom',
        height: 'auto',
        maxHeight: '60vh',
        background: '#ffffff',
        shadow: '0 -2px 8px rgba(0,0,0,0.08)',
        border: '1px solid #e5e7eb'
      },
      grid: {
        columns: 1,
        spacing: 1
      }
    },
    
    caviar: {
      name: 'Caviar Mobile',
      description: 'Elegant Slide Cart',
      layout: 'grid',
      productCard: {
        style: 'mobile-premium',
        imageHeight: 160,
        borderRadius: 12,
        shadow: '0 2px 12px rgba(0,0,0,0.08)',
        padding: 14,
        border: '1px solid #f3f4f6'
      },
      cart: {
        type: 'slide-elegant',
        maxHeight: '75vh',
        background: '#fafafa',
        borderRadius: '20px 20px 0 0',
        shadow: '0 -4px 20px rgba(0,0,0,0.1)'
      },
      grid: {
        columns: 1,
        spacing: 2
      }
    },
    
    instacart: {
      name: 'Instacart Mobile',
      description: 'Quick View Cart',
      layout: 'grid',
      productCard: {
        style: 'mobile-quick',
        imageHeight: 120,
        borderRadius: 10,
        shadow: '0 1px 6px rgba(0,0,0,0.06)',
        padding: 8,
        quickAdd: true
      },
      cart: {
        type: 'quick-view',
        height: 56,
        background: '#ffffff',
        shadow: '0 -2px 8px rgba(0,0,0,0.06)',
        expandable: true,
        compact: true
      },
      grid: {
        columns: 2,
        spacing: 1.5
      }
    }
  }
};

// Helper function to get theme config based on device type
export const getThemeConfig = (desktopTheme, mobileTheme, isMobile) => {
  const themeType = isMobile ? 'mobile' : 'desktop';
  const themeName = isMobile ? mobileTheme : desktopTheme;
  return THEME_CONFIGS[themeType][themeName] || THEME_CONFIGS[themeType].swiggy;
};

// Helper to detect if device is mobile
export const isMobileDevice = () => {
  return window.innerWidth < 768;
};
